export const bannerData = {
    en: {
        description: [
            "Cultivate Good Conduct, Study the Scriptures,",
            "Uplift the Buddha's Teachings"
        ]
    },
    my: {
        description: [
            "အကျင့်လည်းပြင်၊ စာလည်းသင်၊",
            "မြှင့်တင်သာသနာ"
        ]
    },
    photos: [
        '/images/banner/photo1.jpg',
        '/images/banner/photo2.jpg',
        '/images/banner/photo3.jpg'
        // Add more photo paths as needed
    ]
};